import angular from 'angular'

import modal from 'ui-bootstrap4/src/modal'
import { EditFeedbackComponent } from './edit-feedback.component';
import { EditFeedbackModalComponent, EditFeedbackModalController } from './edit-feedback-modal.component';
import { OpenSentryFeedbackDirective } from './open-sentry-feedback.directive';

export const FeedbackModule = angular
    .module("apex.mainApp.feedback", [
        modal
    ])
    .component("apexEditFeedback", EditFeedbackComponent)
    .component(EditFeedbackModalComponent.selector, EditFeedbackModalComponent)
    .controller("EditFeedbackContainerController", EditFeedbackModalController)
    .directive(OpenSentryFeedbackDirective.selector, OpenSentryFeedbackDirective)
    .name
